const intro = document.getElementById('intro');
const audio = document.getElementById('audio');

let start = false;
let canStart = false;
import { launch3D } from "../main.js";

document.getElementById("intro").addEventListener("click", () => {
    launch();
    console.log(ischarged());
});

function launch2(){
    launch3D();
}

function launch(){
    if (!start && ischarged()) {
        launch2();
        start=true;
        audio.currentTime = 1.55;
        const svgImage = document.getElementById('son');
        console.log(svgImage.src);
        if (svgImage.src.includes("img/son2.svg")) {
            audio.play();
        }
        gsap.to("#intro", {
            duration: 0.9,
            opacity: 0,
            ease: "power2.inOut",
            repeat: 0,
            onComplete: function() {
                document.getElementById('intro')?.remove();
            }
        });
    }  
}




